const errorStyles = {
  color: "var(--dy-error-text-color, #d82325)",
  fontFamily: 'var(--dy-error-font-family, "Minion")',
  fontSize: "var(--dy-error-font-size, 1rem)",
  fontWeight: "var(--dy-error-font-weight, 400)",
}
const buttonStyles = {
  color: "var(--dy-btn-primary-text-color, white)",
  backgroundColor: "var(--dy-background-secondary-color, black)",
}
const secondaryButtonStyles = {
  color: "var(--dy-btn-secondary-text-color, #000000)",
  backgroundColor: "var(--dy-btn-secondary-color, #ffffff)",
}
const fadedButtonStyles = {
  color: "var(--dy-btn-faded-text-color, #212529)",
  backgroundColor: "var(--dy-btn-faded-primary-color)",
}
const transparentIconStyles = {
  color: "var(--dy-btn-icon-color, #666666)",
  //This would cause a square to appear -- backgroundColor: 'var(--dy-btn-faded-primary-color)'
}
/**
 * Includes buttons like "REVIEW YOUR SELECTION", "REVIEW YOUR STACK" and "ADD TO BAG", on women's have a black b/g and white text
 * @returns {{backgroundColor: string, color: string}}
 */
export const getButtonStyles = () => buttonStyles
/**
 * Includes buttons like "CHANGE CHAIN", "REARRANGE" that are in oval-shaped containers and on women's have a white bg
 * @returns {{backgroundColor: string, color: string}}
 */
export const getSecondaryButtonStyles = () => secondaryButtonStyles
/**
 * Includes buttons like (X) and hamburger drag handle in rearrange, and "SELECTED" oval with check mark
 * @returns {{backgroundColor: string, color: string}}
 */
export const getFadedButtonStyles = () => fadedButtonStyles
/**
 * Includes buttons like (i) in available products ot stack
 * @returns {*}
 */
export const getTransparentIconStyles = () => transparentIconStyles
/**
 * Includes text error messages in product list pane
 * @returns {{fontFamily: string, color: string, fontSize: string, fontWeight: string}}
 */
export const getErrorStyles = () => errorStyles

// --dy-btn-primary-color: purple;
// --dy-btn-secondary-color: #770055;
// --dy-btn-primary-text-color: #ffccdd;
// --dy-btn-secondar-text-color: #dd44aa;
